import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyleClientAccess = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 2rem;
  .MuiToolbar-regular {
    min-height: 0px;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;
